module.exports = __webpack_public_path__ + "static/media/banner01.0573fced.jpg";